import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, unref as _unref, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-29c4b63b"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "time-range-editor"
};
const _hoisted_2 = ["onClick"];
import { CloseOutlined } from '@ant-design/icons-vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'TimeRangeEditor',
  props: {
    modelValue: null,
    disabled: {
      type: Boolean,
      default: false
    },
    removeStyle: {
      default: 'icon'
    }
  },
  emits: ["update:modelValue"],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const toPickerValue = item => item.startDate && item.endDate ? [item.startDate, item.endDate] : undefined;
    const handleChange = (index, dates) => {
      const next = props.modelValue.map(item => ({
        ...item
      }));
      next[index] = dates && dates.length === 2 ? {
        startDate: dates[0],
        endDate: dates[1]
      } : {
        startDate: '',
        endDate: ''
      };
      emit('update:modelValue', next);
    };
    const handleAdd = () => {
      emit('update:modelValue', props.modelValue.concat([{
        startDate: '',
        endDate: ''
      }]));
    };
    /** 删除最后一段后仍保留一组空输入区域 */
    const handleRemove = index => {
      const next = props.modelValue.filter((_, i) => i !== index);
      emit('update:modelValue', next.length ? next : [{
        startDate: '',
        endDate: ''
      }]);
    };
    return (_ctx, _cache) => {
      const _component_a_range_picker = _resolveComponent("a-range-picker");
      const _component_a_button = _resolveComponent("a-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.modelValue, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: "range-row"
        }, [_createVNode(_component_a_range_picker, {
          class: "range-picker",
          value: toPickerValue(item),
          disabled: __props.disabled,
          "value-format": "YYYY-MM-DD",
          placeholder: ['开始日期', '结束日期'],
          onChange: dates => handleChange(index, dates)
        }, null, 8, ["value", "disabled", "onChange"]), __props.removeStyle === 'text' ? (_openBlock(), _createBlock(_component_a_button, {
          key: 0,
          type: "link",
          danger: "",
          disabled: __props.disabled,
          onClick: $event => handleRemove(index)
        }, {
          default: _withCtx(() => [_createTextVNode(" 删除 ")]),
          _: 2
        }, 1032, ["disabled", "onClick"])) : (_openBlock(), _createElementBlock("span", {
          key: 1,
          class: _normalizeClass(["remove-icon", {
            disabled: __props.disabled
          }]),
          onClick: $event => !__props.disabled && handleRemove(index)
        }, [_createVNode(_unref(CloseOutlined))], 10, _hoisted_2))]);
      }), 128)), __props.removeStyle === 'text' ? (_openBlock(), _createBlock(_component_a_button, {
        key: 0,
        type: "dashed",
        block: "",
        disabled: __props.disabled,
        onClick: handleAdd
      }, {
        default: _withCtx(() => [_createTextVNode(" ＋ 添加时间段 ")]),
        _: 1
      }, 8, ["disabled"])) : (_openBlock(), _createBlock(_component_a_button, {
        key: 1,
        type: "link",
        class: "add-link",
        disabled: __props.disabled,
        onClick: handleAdd
      }, {
        default: _withCtx(() => [_createTextVNode("＋ 添加时间段")]),
        _: 1
      }, 8, ["disabled"]))]);
    };
  }
});